export interface OrgPeriod {
  year: number;
  month: number;
}

export function currentOrgPeriod(now = new Date()): OrgPeriod {
  return {
    year: now.getFullYear(),
    month: now.getMonth() + 1,
  };
}
